var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-html-container',{staticClass:"question-analysis-solution",attrs:{"label":"Analysis & Solution","htmlContent":_vm.analysisSolution}})}
var staticRenderFns = []

export { render, staticRenderFns }